import {
  SET_PRODUCT_GROUPS,
  SET_PRODUCT_GROUPS_ERROR,
  SET_PRODUCT_GROUPS_LOADING,
} from "../../actions/productGroupAction";

const initialState = { datas: {}, loading: false, error: null };

const productGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCT_GROUPS:
      return { ...state, datas: action.data, error: null };
    case SET_PRODUCT_GROUPS_LOADING:
      return { ...state, loading: action.status };
    case SET_PRODUCT_GROUPS_ERROR:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};

export default productGroupReducer;
